import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { authGuard } from './core/auth/auth.guard';

export const appRoutes: VexRoutes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/pages/auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import(
        './pages/pages/auth/forgot-password/forgot-password.component'
      ).then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () =>
      import('./pages/pages/coming-soon/coming-soon.component').then(
        (m) => m.ComingSoonComponent
      )
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      // delete routes
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/dashboards/sleep-analytics/sleep-analytics.component'
          ).then((m) => m.SleepAnalyticsComponent)
      },
      {
        path: 'apps',
        children: [
          {
            path: 'chat',
            loadChildren: () => import('./pages/apps/chat/chat.routes')
          },
          {
            path: 'mail',
            loadChildren: () => import('./pages/apps/mail/mail.routes'),
            data: {
              toolbarShadowEnabled: true,
              scrollDisabled: true
            }
          },
          {
            path: 'social',
            loadChildren: () => import('./pages/apps/social/social.routes')
          },
          {
            path: 'contacts',
            loadChildren: () => import('./pages/apps/contacts/contacts.routes')
          },
          {
            path: 'calendar',
            loadComponent: () =>
              import('./pages/apps/calendar/calendar.component').then(
                (m) => m.CalendarComponent
              ),
            data: {
              toolbarShadowEnabled: true
            }
          },
          {
            path: 'aio-table',
            loadComponent: () =>
              import('./pages/apps/aio-table/aio-table.component').then(
                (m) => m.AioTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'scrumboard',
            loadChildren: () =>
              import('./pages/apps/scrumboard/scrumboard.routes')
          },
          {
            path: 'editor',
            loadComponent: () =>
              import('./pages/apps/editor/editor.component').then(
                (m) => m.EditorComponent
              ),
            data: {
              scrollDisabled: true
            }
          }
        ]
      },
      {
        path: 'pages',
        children: [
          {
            path: 'pricing',
            loadComponent: () =>
              import('./pages/pages/pricing/pricing.component').then(
                (m) => m.PricingComponent
              )
          },
          {
            path: 'faq',
            loadComponent: () =>
              import('./pages/pages/faq/faq.component').then(
                (m) => m.FaqComponent
              )
          },
          {
            path: 'invoice',
            loadComponent: () =>
              import('./pages/pages/invoice/invoice.component').then(
                (m) => m.InvoiceComponent
              )
          },
          {
            path: 'error-404',
            loadComponent: () =>
              import('./pages/pages/errors/error-404/error-404.component').then(
                (m) => m.Error404Component
              )
          },
          {
            path: 'error-500',
            loadComponent: () =>
              import('./pages/pages/errors/error-500/error-500.component').then(
                (m) => m.Error500Component
              )
          }
        ]
      },
      {
        path: 'ui',
        children: [
          {
            path: 'components',
            loadChildren: () =>
              import('./pages/ui/components/components.routes')
          },
          {
            path: 'forms/form-elements',
            loadComponent: () =>
              import(
                './pages/ui/forms/form-elements/form-elements.component'
              ).then((m) => m.FormElementsComponent)
          },
          {
            path: 'forms/form-wizard',
            loadComponent: () =>
              import('./pages/ui/forms/form-wizard/form-wizard.component').then(
                (m) => m.FormWizardComponent
              )
          },
          {
            path: 'icons',
            loadChildren: () => import('./pages/ui/icons/icons.routes')
          },
          {
            path: 'page-layouts',
            loadChildren: () =>
              import('./pages/ui/page-layouts/page-layouts.routes')
          }
        ]
      },
      //end delete routes

      // general routes
      {
        path: 'documentation',
        loadComponent: () => import('./pages/documentation/documentation.component').then(m => m.DocumentationComponent)
      },
      {
        path: 'resume',
        loadComponent: () => import('./gosleep/resume/resume.component')
      },
      {
        path: 'account-settings',
        loadComponent: () => import('./gosleep/account-settings/account-settings.component')
      },
      {
        path: 'risk',
        loadComponent: () => import('./gosleep/risk-editor/risk-editor.component')
      },
      {
        path: 'reports',
        loadComponent: () => import('./gosleep/reports/reports.component')
      },
      // routes-admin
      {
        path: 'admin',
        children: [
          {
            path: 'service',
            loadComponent: () =>
              import('./gosleep/admin/service-control/service-control.component').then(
                (m) => m.ServiceControlComponent
              )
          },
          {
            path: 'auth',
            loadComponent: () =>
              import('./gosleep/admin/auth-control/auth-control.component').then(
                (m) => m.AuthControlComponent
              )
          },
          {
            path: 'company',
            loadComponent: () =>
              import('./gosleep/admin/company-control/company-control.component').then(
                (m) => m.CompanyControlComponent
              )
          },
          {
            path: 'client',
            loadComponent: () =>
              import('./gosleep/admin/client-control/client-control.component').then(
                (m) => m.ClientControlComponent
              )
          },
          {
            path: 'contract',
            loadComponent: () =>
              import('./gosleep/admin/contract-control/contract-control.component').then(
                (m) => m.ContractControlComponent
              )
          },
          {
            path: 'device',
            loadComponent: () =>
              import('./gosleep/admin/device-control/device-control.component').then(
                (m) => m.DeviceControlComponent
              )
          },
          {
            path: 'email',
            loadComponent: () =>
              import('./gosleep/admin/email-control/email-control.component').then(
                (m) => m.EmailControlComponent
              )
          },

        ]
      },
      // end-routes-admin

      {
        path: '**',
        loadComponent: () =>
          import('./pages/pages/errors/error-404/error-404.component').then(
            (m) => m.Error404Component
          )
      }
    ],
    canActivate: [authGuard]
  }
];
